{
  "external.scopes": "Àmbits autoritzats",
  "external.selectAll": "Seleccionar tots els actuals",
  "external.futureScopes": "Els àmbits nous requeriran autorització explícita.",
  "external.channels": "Canals",
  "external.api": "API",
  "external.mcp": "MCP",
  "external.permission": "Permisos",
  "external.readOnly": "Només lectura",
  "external.readWrite": "Lectura i escriptura",
  "external.advanced": "Permisos avançats",
  "external.deletePermission": "Permetre eliminar tasques i esdeveniments per API",
  "external.expiry": "Caducitat",
  "external.noExpiry": "Deixa la data buida per no posar caducitat.",
  "external.save": "Desar",
  "external.cancel": "Cancel·lar",
  "external.probeFailed": "La comprovació MCP ha fallat (HTTP {status}). Revisa el canal i els permisos de lectura.",
  "external.switchHelp": "Pausa l’accés extern sense esborrar les credencials. Afecta també els agents IA. La web i Android continuen funcionant.",
  "external.apiEnabled": "Activar accés API extern",
  "external.mcpEnabled": "Activar accés MCP",
  "external.connect": "Connectar una aplicació",
  "external.client": "Aplicació",
  "external.client.chatgpt": "ChatGPT",
  "external.client.claude": "Claude",
  "external.client.hermes": "Hermes",
  "external.guide.chatgpt": "A ChatGPT, activa el mode desenvolupador si el teu compte ho permet. Afegeix un servidor MCP a l’apartat de plugins/connectors, enganxa aquesta URL i selecciona OAuth. S’obrirà Fem-ho per iniciar sessió i autoritzar-lo. La disponibilitat depèn del compte i de la política de l’espai de treball.",
  "external.guide.claude": "A Claude, ves a Ajustos → Connectors → Afegir connector personalitzat. Enganxa aquesta URL i connecta’l. Autoritza els àmbits i permisos a Fem-ho quan s’obri el navegador.",
  "external.guide.hermes": "Afegeix aquesta entrada a mcp_servers del fitxer de configuració d’Hermes. En connectar, completa l’autorització OAuth al navegador. Després demana whoami i list_tasks per comprovar l’accés.",
  "external.oauthPermissions": "Cada connexió autoritza els seus propis àmbits i permisos. Pots revocar-la a la llista de credencials. L’URL ha de ser HTTPS i accessible des del client.",
  "external.manual": "Alternativa amb token manual",
  "external.envHelp": "Crea un token amb canal MCP i defineix FEMHO_MCP_TOKEN a l’entorn d’Hermes. El secret només es mostra una vegada.",
  "external.documentation": "Veure la documentació oficial",
  "external.check": "Comprovar connexió MCP",
  "external.verified": "Connexió verificada: identitat i lectura de tasques correctes.",
  "external.closeSecret": "Ja he desat el token",
  "external.agentCredential": "Credencial d’agent IA",
  "external.oauthCredential": "Connexió OAuth",
  "external.unavailableScope": "Àmbit no disponible",
  "external.inheritedScopes": "Hereta els àmbits de l’agent",
  "external.emptyScopes": "Sense àmbits: edita el token per donar-li accés.",
  "external.permissionsDetail": "Permisos detallats",
  "external.lastUsed": "Últim ús: {date}",
  "external.expires": "Caduca: {date}",
  "external.never": "Sense caducitat",
  "external.revoked": "Revocat",
  "external.expired": "Caducat",
  "external.paused": "Pausat",
  "external.active": "Actiu",
  "external.edit": "Editar",
  "external.reconnect": "Per canviar els permisos, revoca aquesta connexió i torna a connectar des de l’aplicació.",
  "external.authorize": "Autoritzar connexió a Fem-ho",
  "external.consentHelp": "Aquesta aplicació podrà accedir a totes les tasques dels àmbits que seleccionis, inclòs Inbox. Tria només els permisos que necessiti.",
  "external.enableForConsent": "Activar el meu accés MCP i autoritzar aquesta connexió",
  "external.allow": "Autoritzar",
  "external.deny": "Denegar",
  "settings.mail.pollInterval": "Consulta del correu",
  "settings.mail.pollDefault": "Per defecte · 5 minuts",
  "settings.mail.pollMinutes": "Cada {count} min",
  "settings.mail.pollHelp": "Consulta periòdica, no immediata. Pot trigar fins a 30 segons més; si hi ha errors, els reintents s’espaiaran.",
  "settings.mail.oauth.title": "Gmail i Google Workspace",
  "settings.mail.oauth.help": "Autoritza l’accés amb Google i torna aquí per confirmar l’adreça. Fem-ho llegirà el correu sense modificar els missatges.",
  "settings.mail.oauth.confirmEmail": "Connectar el correu {email}?",
  "settings.mail.oauth.connected": "Connectat amb Google",
  "settings.mail.oauth.disconnected": "Google desconnectat",
  "settings.mail.oauth.reconnect_required": "Cal tornar a autoritzar Google",
  "settings.mail.oauth.pending": "Completa l’autorització al navegador i torna a aquesta pantalla.",
  "settings.mail.oauth.confirm": "Confirma la connexió",
  "settings.mail.oauth.cancel": "Tanca o cancel·la",
  "settings.mail.oauth.account": "Compte de Google",
  "settings.mail.oauth.new": "Connecta un compte nou",
  "settings.mail.oauth.connect": "Connecta amb Google",
  "settings.mail.oauth.reconnect": "Torna a connectar Google",
  "settings.mail.oauth.disconnect": "Desconnecta Google",
  "settings.mail.oauth.error.cancelled": "Autorització cancel·lada. El compte no s’ha modificat.",
  "settings.mail.oauth.error.expired": "L’intent ha caducat. Torna a connectar Google.",
  "settings.mail.oauth.error.missing_scope": "Google no ha concedit el permís de correu necessari per a IMAP.",
  "settings.mail.oauth.error.missing_refresh_token": "Google no ha concedit accés continuat. Torna a autoritzar el compte.",
  "settings.mail.oauth.error.identity_mismatch": "Has triat un altre correu de Google. Selecciona l’adreça del compte que vols reconnectar.",
  "settings.mail.oauth.error.account_exists": "Aquest correu ja existeix. Selecciona’l a la llista per reconnectar-lo.",
  "settings.mail.oauth.error.not_configured": "L’administrador ha de configurar OAuth de Google en aquesta instància.",
  "settings.mail.oauth.error.reconnect_required": "Google ha revocat o ha fet caducar l’accés. Torna a connectar el compte.",
  "settings.mail.oauth.error.not_ready": "L’autorització encara no està preparada. Completa-la al navegador o inicia un altre intent.",
  "settings.mail.oauth.error.generic": "No s’ha pogut completar la connexió amb Google. Torna-ho a provar.",
  "$comment": [
    "Cataleg catala de la interficie. Regla 3: la interficie es en catala, sempre via",
    "fitxers de traduccio, mai literals al codi.",
    "",
    "AQUEST MATEIX FITXER alimenta la web i el strings.xml d'Android (docs/03 §1). Un",
    "literal escrit a la web es una divergencia garantida amb Android.",
    "",
    "Els textos surten del prototip caracter a caracter: docs/02 §3 diu que quan el",
    "document i el prototip coincideixin, mana el prototip en textos catalans.",
    "",
    "Convencions de docs/00: sentence case a tot arreu, MAJUSCULES nomes als epigrafs",
    "petits, el punt volat · com a separador, els botons que afegeixen amb un + literal,",
    "els marcadors de posicio acaben amb … d'un sol caracter, frases senceres als estats",
    "buits, i CAP EMOJI."
  ],
  "activity.filter.ai": "Només IA",
  "activity.filter.all": "Tot",
  "activity.filter.human": "Només persones",
  "activity.undo": "Desfés",
  "activity.verb.answered": "has respost",
  "activity.verb.asked": "t'ha preguntat",
  "activity.verb.cascade_complete": "s'ha completat en cascada",
  "activity.verb.claimed": "ha reservat la tasca",
  "activity.verb.commented": "ha comentat",
  "activity.verb.completed": "ha completat",
  "activity.verb.created": "ha creat la tasca",
  "activity.verb.deleted": "ha esborrat",
  "activity.verb.moved": "ha mogut",
  "activity.verb.refreshed": "ha refrescat l'origen",
  "activity.verb.released": "ha alliberat la tasca",
  "activity.verb.reopened": "ha reobert",
  "activity.verb.token_created": "ha creat un token",
  "activity.verb.token_revoked": "ha revocat un token",
  "activity.verb.updated": "ha canviat",
  "ai.attention.attachHint": "El que adjuntis a la tasca li arriba amb la feina.",
  "ai.attention.card": "Espera resposta",
  "ai.attention.pending": "{count} tasques esperen resposta teva",
  "ai.attention.waiting": "L'agent espera una resposta teva per poder seguir. Marxa quan responguis.",
  "ai.coverage.disabled": "L'agent «{agent}», que porta «{scope}», està aturat: no agafarà res.",
  "ai.coverage.fix": "Assignar-ne un",
  "ai.coverage.none": "Cap agent no porta «{scope}»: el que hi deixis aquí es quedarà sense fer.",
  "ai.lock.card": "L'agent hi treballa",
  "ai.lock.working": "L'agent hi està treballant. Es desbloqueja sola a les {time}.",
  "ai.mode.assisted": "Amb ajuda",
  "ai.mode.cycle": "Canvia el mode d'IA",
  "ai.mode.delegated": "IA",
  "ai.mode.manual": "Individual",
  "ai.proof.openTask": "Obre la tasca",
  "ai.proof.taskTitle": "Preparar la reunió de dilluns",
  "ai.proof.toggleLease": "Reserva",
  "ai.readAt": "L'agent ho va llegir {when}.",
  "ai.status.configuredButUnused": "Hi ha credencials d’un model, i encara no hi ha res que les faci servir.",
  "ai.status.credentialsWithoutProvider": "Hi ha una clau o un model configurats sense proveïdor: no es faran servir.",
  "ai.takeOver.action": "Ho agafo jo",
  "ai.takeOver.where": "A quina columna?",
  "ai.unseen": "Hi ha hagut un canvi autònom que no has vist",
  "app.name": "Fem-ho",
  "board.card.advance": "Moure a {column}",
  "board.column.doing": "Fent",
  "board.column.done": "Fet",
  "board.column.inbox": "Inbox",
  "board.column.todo": "Per fer",
  "board.done.backToToday": "Tornar a avui",
  "board.done.clear": "Netejar",
  "board.done.emptyDay": "Cap tasca feta el {day}.",
  "board.done.showAllToday": "Tot avui",
  "board.done.thisWeek": "Aquesta setmana",
  "board.done.yesterday": "Ahir",
  "board.drag.cancelled": "Moviment cancel·lat.",
  "board.drag.grabbed": "{title} agafada. Fes servir les fletxes per moure-la i espai per deixar-la anar.",
  "board.drag.moved": "{title} moguda a {column}.",
  "board.empty.doing": "Res en marxa ara mateix.",
  "board.empty.done": "Encara no has acabat res avui.",
  "board.empty.inbox": "Cap tasca a la bústia.",
  "board.empty.todo": "Cap tasca a Per fer.",
  "board.fullEdit": "Edició completa",
  "board.ia.badge": "Kanban de la IA",
  "board.ia.empty": "La IA no té res en aquesta columna.",
  "board.ia.newTask": "Nova tasca per a la IA",
  "board.ia.toggle": "Kanban de la IA",
  "board.others": "Veure tasques d'altres",
  "board.quickAdd.failed": "No s'ha pogut crear. Torna-ho a provar.",
  "board.quickAdd.placeholder.person": "+ Afegir a {column}… @Persona",
  "board.quickAdd.placeholder.plain": "+ Afegir a {column}…",
  "board.quickAdd.placeholder.scope": "+ Afegir a {column}… #Àmbit",
  "board.quickAdd.revert": "Tornar «{label}» a text",
  "board.quickAdd.scopeRequired": "Indica l'àmbit amb #{scopes}",
  "board.quickAdd.scopeRequiredPrefix": "Indica l'àmbit amb #",
  "calendar.addOnDay": "Afegir una tasca aquest dia",
  "calendar.day": "Diari",
  "calendar.empty.day": "Sense esdeveniments ni tasques aquest dia.",
  "calendar.empty.week": "Sense res",
  "calendar.event.fromInbox": "Treure de la bústia",
  "calendar.event.inInbox": "És a la teva bústia.",
  "calendar.event.notInInbox": "No és a la teva bústia: al calendari hi és, però no et reclama el dia.",
  "calendar.event.toInbox": "Posar a la bústia",
  "calendar.month": "Mensual",
  "calendar.nextMonth": "Mes següent",
  "calendar.noDate": "SENSE DIA",
  "calendar.prevMonth": "Mes anterior",
  "calendar.sources": "Fonts",
  "calendar.sources.hide": "Amagar «{name}» del calendari",
  "calendar.sources.show": "Veure «{name}» al calendari",
  "calendar.week": "Setmanal",
  "card.add": "Afegir subtasca o llista",
  "card.addPlaceholder": "Nova subtasca… o #Llista element",
  "card.lists.collapsed": "▸ Llistes ({count})",
  "card.lists.expanded": "▾ Llistes ({count})",
  "checklist.addItem": "+ Afegir ítem…",
  "checklist.completed": "Completats",
  "checklist.completedInline": "Fets en línia",
  "checklist.completedSection": "Fets en una secció",
  "checklist.completedWhere": "On van els ítems fets",
  "checklist.count": "{done}/{total}",
  "checklist.done": "Llista completada. Vols despinejar-la?",
  "checklist.empty": "Aquesta llista encara no té cap ítem.",
  "checklist.keep": "Mantenir",
  "checklist.pin": "Pineja",
  "checklist.showCompleted": "Completats",
  "checklist.toggleItem": "Marca o desmarca «{text}»",
  "checklist.unpin": "Despinejar",
  "checklist.unpinAction": "Despineja",
  "dashboard.doing": "Fent ara",
  "dashboard.empty.doing": "Res en marxa ara mateix.",
  "dashboard.empty.overdue": "No hi ha res endarrerit.",
  "dashboard.empty.today": "Res per avui.",
  "dashboard.overdue": "Endarrerides",
  "dashboard.overdueCount": "{count} endarrerides",
  "dashboard.pending": "{count} pendents",
  "dashboard.quickAdd": "+ Afegir… #Àmbit @Persona",
  "dashboard.title": "Tauler general",
  "dashboard.today": "Avui",
  "error.body-required": "Un comentari buit no diu res: escriu-hi el motiu.",
  "error.calendar-not-empty": "«{name}» encara té {count} esdeveniments. Mou-los o esborra'ls abans.",
  "error.calendar-read-only": "«{name}» és una font de només lectura i no s'hi pot escriure.",
  "error.cannot-delete-self": "No et pots esborrar el teu compte des d'Admin. Demana-ho a un altre administrador.",
  "error.capabilities-exceeded": "Cap de les capacitats demanades és teva: un token no pot fer més que qui el crea.",
  "error.capabilities-required": "Un token sense cap capacitat no pot fer res: tria'n almenys una.",
  "error.claimed-by-other": "Un altre agent la té reservada durant {minutes} min més.",
  "error.confirmation-mismatch": "Per netejar la instància, escriu-ne el nom exacte: «{name}».",
  "error.email-taken": "Ja hi ha un compte amb {email}.",
  "error.endpoint-required": "Cal dir quin endpoint es dona de baixa.",
  "error.event-incomplete": "Un esdeveniment necessita calendari, títol i instant d'inici.",
  "error.generic": "Alguna cosa ha fallat.",
  "error.human-took-over": "Aquesta tasca l'ha assumida una persona: ja no és de la IA.",
  "error.invalid-ai-mode": "El mode ha de ser individual, amb ajuda o delegat.",
  "error.invalid-credentials": "Correu o contrasenya incorrectes.",
  "error.invalid-email": "Això no sembla un correu.",
  "error.invalid-permission": "El permís ha de ser mirar, marcar o comentar. No existeix el d'edició.",
  "error.invalid-subscription": "A aquesta subscripció li falten dades.",
  "error.invalid-timezone": "«{value}» no és cap fus horari. Fes servir un nom com Europe/Madrid.",
  "error.invalid-value": "«{value}» no és un valor de {field}. Els vàlids són: {allowed}.",
  "error.invite-invalid": "Aquesta invitació no és vàlida, ja s'ha fet servir o ha caducat.",
  "error.label-other-scope": "L'etiqueta {name} és d'un altre àmbit. Crea-la també en aquest.",
  "error.last-admin": "És l'últim administrador. La instància es quedaria sense ningú que la pogués administrar.",
  "error.last-owner": "{name} es quedaria sense cap propietari. Fes propietari algú altre primer.",
  "error.member-shape": "Un membre és una persona o una subscripció de calendari, mai totes dues coses ni cap.",
  "error.missing-capability": "Aquest token no té la capacitat «{capability}».",
  "error.name-required": "Un token sense nom no es distingeix dels altres, i llavors no se'n pot revocar cap amb confiança.",
  "error.no-lease": "Aquesta tasca no està reservada.",
  "error.not-a-member": "{person} no és membre de {scope}: no podria obrir la tasca.",
  "error.not-claimed": "Aquesta tasca no la tens reservada.",
  "error.not-creatable": "Això no es pot crear des d'un lot.",
  "error.not-found": "Això ja no hi és.",
  "error.not-owner": "L'àmbit {name} només el pot esborrar qui el va crear.",
  "error.not-undoable": "Això no és un canvi autònom d'IA amb valors anteriors: no hi ha res a restaurar.",
  "error.occurrence-required": "Cal saber quina ocurrència es toca.",
  "error.parent-required": "Falta dir a on va.",
  "error.password-too-short": "La contrasenya ha de tenir com a mínim 10 caràcters.",
  "error.project-other-scope": "El projecte {name} és d'un altre àmbit. Una tasca no canvia d'àmbit editant-la.",
  "error.reason-required": "Alliberar una tasca necessita un motiu: el següent agent l'ha de poder llegir.",
  "error.retry": "Reintentar",
  "error.scope-forbidden": "Aquest token no arriba a aquest àmbit. Veu: {visible}.",
  "error.scope-not-collective": "L'àmbit {name} és individual: no té membres. Els col·lectius sí.",
  "error.scope-not-empty": "L'àmbit {name} encara té {contents}. Mou-ho o esborra-ho abans.",
  "error.scope-required": "Això sempre pertany a un àmbit.",
  "error.setup-closed": "Aquesta instància ja té administrador.",
  "error.share-revoked": "Aquest enllaç està revocat: no es pot tornar a obrir. Crea'n un de nou.",
  "error.source-url-required": "La font necessita una adreça.",
  "error.target-required": "Un enllaç és per a una tasca o per a una llista, no per a totes dues ni per a cap.",
  "error.task-locked": "L'agent «{agent}» hi està treballant ara mateix. Es desbloquejarà sola d'aquí a {minutes} min.",
  "error.text-required": "Això no pot quedar buit.",
  "error.title-required": "El títol no pot quedar buit.",
  "error.too-many-attempts": "Massa intents. Torna-ho a provar d'aquí a {seconds} segons.",
  "error.unauthenticated": "Cal tornar a entrar.",
  "error.unknown-entity": "Això no és una cosa que se sincronitzi.",
  "error.unreachable": "El servidor no contesta. No és el que has escrit: mira si la instància està engegada.",
  "error.version-conflict": "Algú altre ho ha canviat mentrestant.",
  "error.weak-share-password": "La contrasenya de l'enllaç necessita {min} caràcters com a mínim.",
  "error.window-invalid": "Les dates del període no són vàlides.",
  "error.window-required": "Cal un període: sense ell no es poden expandir les repeticions.",
  "error.wrong-component": "«{name}» és de tasques i no accepta esdeveniments.",
  "error.wrong-password": "La contrasenya actual no és correcta.",
  "inbox.day.next": "El dia següent",
  "inbox.day.pick": "Triar el dia",
  "inbox.day.prev": "El dia abans",
  "inbox.day.today": "Avui",
  "inbox.event.allDay": "Tot el dia",
  "inbox.event.toTask": "Fer-ne una tasca",
  "inbox.eye.hide": "Treure de l’inbox de Tasques",
  "inbox.eye.show": "Portar a l’inbox de Tasques",
  "inbox.mail.noSubject": "(sense assumpte)",
  "inbox.mail.unknownSender": "Sense remitent",
  "inbox.mailbox": "Què es veu a la bústia",
  "inbox.mailbox.all": "Tot",
  "inbox.mailbox.allHint": "Tota la bústia: els àmbits individuals i els compartits",
  "inbox.mailbox.own": "Individuals",
  "inbox.mailbox.ownHint": "Només el que hi ha als teus àmbits individuals",
  "inbox.mailbox.shared": "Compartits",
  "inbox.mailbox.sharedHint": "Només el que hi ha als àmbits que comparteixes amb algú",
  "inbox.section.events": "Del calendari",
  "inbox.section.mail": "Del correu",
  "invite.done": "Ja pots entrar amb el teu correu i aquesta contrasenya.",
  "invite.mismatch": "Les dues contrasenyes no coincideixen.",
  "invite.password": "Contrasenya",
  "invite.repeat": "Repeteix-la",
  "invite.subtitle": "Aquest enllaç serveix un sol cop.",
  "invite.title": "Tria la teva contrasenya",
  "invite.tooShort": "Ha de tenir com a mínim 10 caràcters.",
  "join.accept": "Entrar-hi",
  "join.done": "Ja hi ets",
  "join.invalid": "Aquest convit no és vàlid: pot ser que ja s'hagi fet servir, o que hagi caducat.",
  "join.subtitle": "{who} et convida a «{scope}»",
  "join.title": "Un convit",
  "login.checkServer": "Comprovar",
  "login.email": "Correu",
  "login.error": "Correu o contrasenya incorrectes.",
  "login.forgot": "Has oblidat la contrasenya?",
  "login.insecure": "Aquesta adreça no va xifrada. Qualsevol de la xarxa pot llegir el que hi passi.",
  "login.password": "Contrasenya",
  "login.register": "Fer-se un compte",
  "login.server": "Servidor",
  "login.serverHint": "L'adreça del teu servidor de Fem-ho",
  "login.serverNewer": "El servidor és més nou que aquesta app. Actualitza-la.",
  "login.serverUnreachable": "No hi ha cap Fem-ho en aquesta adreça.",
  "login.submit": "Entrar",
  "login.subtitle": "El gestor de tasques per a tu i la família",
  "nav.add": "Afegir",
  "nav.allProjects": "Tots els projectes",
  "nav.back": "‹ Enrere",
  "nav.backToBoard": "‹ Tornar al tauler",
  "nav.calendar": "Calendari",
  "nav.cancel": "Cancel·la",
  "nav.close": "Tanca",
  "nav.create": "Crea",
  "nav.dashboard": "Tauler general",
  "nav.delete": "Esborra",
  "nav.estadistiques": "Estadístiques",
  "nav.lastScope": "Ha de quedar almenys un àmbit actiu.",
  "nav.logout": "Tancar sessió",
  "nav.newChecklist": "+ Nova llista",
  "nav.newChecklistFull": "Nova llista de tasques senzilles",
  "nav.newProject": "+ Nou projecte",
  "nav.newProject.client": "Nou client",
  "nav.noPinned": "Cap llista pinejada. Pineja una llista senzilla des d'una tasca.",
  "nav.openDashboard": "Obre el tauler general",
  "nav.pinned": "Llistes pinejades",
  "nav.pinnedProgress": "{done} de {total} fets",
  "nav.profile": "El teu compte",
  "nav.projectToggle": "Mostra o amaga el projecte {name}",
  "nav.registre": "Registre",
  "nav.rename": "Reanomena",
  "nav.retry": "Reintentar",
  "nav.save": "Desa",
  "nav.scopePicker": "En quin àmbit estàs",
  "nav.scopeProjects": "Projectes de l'àmbit {name}",
  "nav.scopeToggle": "Mostra o amaga l'àmbit {name}",
  "nav.search": "Cercar",
  "nav.settings": "Ajustos",
  "nav.tasks": "Tasques",
  "nav.view": "Vista",
  "notify.reminder": "Recordatori",
  "palette.empty": "Res que coincideixi.",
  "palette.go": "Anar a",
  "palette.placeholder": "Escriu per anar a un lloc o buscar una tasca…",
  "palette.tasks": "Tasques",
  "quickadd.groupOwn": "Els meus",
  "quickadd.groupShared": "Compartits",
  "register.error": "No s'ha pogut crear el compte.",
  "register.haveAccount": "Ja tinc compte",
  "register.name": "Nom d'usuari",
  "register.submit": "Crear el compte",
  "register.subtitle": "Escull un nom i una contrasenya. Ja podràs canviar-ho des d'Ajustos.",
  "register.title": "Fer-se un compte",
  "registre.allProjects": "Tots els projectes",
  "registre.allProjects.client": "Tots els clients",
  "registre.chrono.addLane": "+ Afegeix un projecte…",
  "registre.chrono.fit": "Ajusta",
  "registre.chrono.hint": "Arrossega un bloc per moure'l i les vores per allargar-lo. S'ajusta a 5 min.",
  "registre.chrono.zoom": "Zoom",
  "registre.col.person": "Persona",
  "registre.col.project": "Projecte",
  "registre.col.project.client": "Client",
  "registre.col.task": "Tasca",
  "registre.col.time": "Dedicació",
  "registre.col.type": "Tipologia",
  "registre.col.when": "Data i hora",
  "registre.day": "Dia",
  "registre.empty": "Encara no hi ha res registrat en aquest període.",
  "registre.everyone": "Tothom",
  "registre.export": "Exporta CSV",
  "registre.noProject": "Intern",
  "registre.noScopes": "Cap àmbit actiu porta registre de dedicació. S'activa a Ajustos ▸ Àmbits.",
  "registre.open": "S'està fent ara mateix.",
  "registre.overtimeCell": "{time} fora d'horari",
  "registre.overtimeTotal": "{time} fora d'horari",
  "registre.period.all": "Tot",
  "registre.period.days30": "Últims 30 dies",
  "registre.period.days90": "Últims 90 dies",
  "registre.period.month": "Aquest mes",
  "registre.period.today": "Avui",
  "registre.period.week": "Aquesta setmana",
  "registre.review": "Fa molta estona seguida: val la pena mirar-s'ho.",
  "registre.search": "Cerca…",
  "registre.subtitle": "Totes les tasques fetes: quan, per a quin projecte, qui i quanta dedicació.",
  "registre.summary": "{tasks} tasques · {time} de dedicació registrada",
  "registre.timezone": "Les hores es veuen en {zone}.",
  "registre.title": "Registre",
  "registre.view.chrono": "Cronograma",
  "registre.view.table": "Taula",
  "settings.about": "Sobre",
  "settings.accent": "Accent",
  "settings.accent.default": "Per defecte",
  "settings.accent.mono-cool": "Fred",
  "settings.accent.mono-warm": "Càlid",
  "settings.accent.soft": "Suau",
  "settings.addMember": "+ Afegir membre",
  "settings.agentAllScopes": "Tots els àmbits",
  "settings.agentCanCreate": "Pot crear tasques",
  "settings.agentConnect": "Com s'hi connecta",
  "settings.agentCredentials": "Credencials",
  "settings.agentDownloadMcp": "Baixa el .mcp.json",
  "settings.agentDownloadSkill": "Baixa el full d'instruccions",
  "settings.agentEnabled": "Actiu",
  "settings.agentMcpHasToken": "Porta la credencial: qui tingui aquest fitxer pot llegir i escriure les teves tasques.",
  "settings.agentMcpNoToken": "Hi falta la credencial: crea'n una i copia'l llavors, que és quan es veu.",
  "settings.agentNewCredential": "+ Nova credencial",
  "settings.agentScopeTaken": "Aquest àmbit el porta «{name}»: un àmbit només pot tenir un agent.",
  "settings.agentScopes": "Àmbits que porta",
  "settings.agentSkillNoToken": "No porta cap credencial: és només com s'ha de comportar.",
  "settings.agents": "Agents",
  "settings.branding": "Logo de la instància",
  "settings.branding.fixed": "El logo el posa la configuració del servidor (FEMHO_LOGO_URL) i no es pot canviar des d’aquí.",
  "settings.branding.help": "SVG, PNG o WebP, com a molt 512 KB. Es veu a la barra, al login i a la pàgina d’un enllaç compartit.",
  "settings.branding.none": "Aquesta instància encara no té logo: es veu el seu nom.",
  "settings.branding.remove": "Treure el logo",
  "settings.caldavEvents": "Esdeveniments",
  "settings.caldavTodos": "Tasques",
  "settings.caldavUrls": "Els teus CalDAV de Fem-ho",
  "settings.calendarCredWarning": "Aquest calendari té credencials guardades. Els membres en veuran els esdeveniments, però les credencials no surten mai. Si a més és bidireccional, el que editin s'escriurà al servei d'un tercer amb les teves.",
  "settings.calendarPrivate": "Només per a tu",
  "settings.calendarShared": "Compartit",
  "settings.calendarSource": "Origen CalDAV",
  "settings.changePassword": "Canviar la contrasenya",
  "settings.credits": "Fem-ho © 2026 Borja Balsera · El sistema de disseny és Plou, d’un producte a part i amb condicions pròpies · Tipografia Roboto (SIL Open Font License) · Vegeu el fitxer NOTICE del repositori",
  "settings.currentPassword": "Contrasenya actual",
  "settings.dashboardItems": "Què es veu al tauler general",
  "settings.day.fri": "dv",
  "settings.day.mon": "dl",
  "settings.day.sat": "ds",
  "settings.day.sun": "dg",
  "settings.day.thu": "dj",
  "settings.day.tue": "dt",
  "settings.day.wed": "dc",
  "settings.empty.agents": "Encara no has creat cap agent.",
  "settings.empty.calendars": "Encara no hi ha contingut per a Calendaris.",
  "settings.empty.shares": "Encara no hi ha contingut per a Compartits.",
  "settings.enableAi": "Activar l'usuari IA",
  "settings.events.onDelete": "En esborrar una tasca feta des d'una cita",
  "settings.events.onDelete.hide": "La cita es queda fora",
  "settings.events.onDelete.hideHint": "Segueix al calendari, però no et torna a reclamar el dia.",
  "settings.events.onDelete.return": "La cita torna a la bústia",
  "settings.events.onDelete.returnHint": "Esborrar la tasca desfà la conversió.",
  "settings.gravatar": "Fer servir Gravatar per a la meva foto",
  "settings.gravatarFill": "Omplir amb el que hi ha a Gravatar",
  "settings.gravatarHelp": "El servidor demana la teva foto a gravatar.com amb el hash del teu correu. El hash no és anònim: qui ja sospiti la teva adreça la pot comprovar. Si ho treus, es veuran les teves inicials.",
  "settings.gravatarNothing": "Gravatar no té res per a aquest correu.",
  "settings.inbox.below": "A sota",
  "settings.inbox.left": "Esquerra",
  "settings.inbox.right": "Dreta",
  "settings.inboxPosition": "Posició del rail d'Inbox",
  "settings.inboxShowOverdue": "L'Inbox ensenya les endarrerides",
  "settings.invite": "Convidar algú",
  "settings.inviteCreate": "Crear convit",
  "settings.inviteEmail": "Correu",
  "settings.inviteLink": "Enllaç d'invitació",
  "settings.inviteName": "Nom",
  "settings.inviteNone": "Cap convit obert.",
  "settings.inviteOnce": "Copia'l ara: no es podrà tornar a veure.",
  "settings.inviteOpen": "Convits oberts",
  "settings.invitePending": "Convidat, encara no ha entrat",
  "settings.inviteRevoke": "Revocar",
  "settings.inviteRole": "Què podrà fer",
  "settings.language": "Idioma",
  "settings.longSession": "Marca per revisar a partir de (hores)",
  "settings.mail.accounts": "Comptes",
  "settings.mail.add": "Afegeix el compte",
  "settings.mail.addRule": "Mapa la carpeta",
  "settings.mail.appPassword": "Fastmail i iCloud necessiten una contrasenya d’aplicació. A Gmail personal, activa la verificació en dos passos i usa la contrasenya d’aplicació de 16 caràcters; pots enganxar-la amb espais. Si l’administrador de Google Workspace exigeix OAuth, Fem-ho encara no pot connectar el compte.",
  "settings.mail.attachmentsToTask": "Els adjunts del correu, a la tasca",
  "settings.mail.bodyToDescription": "El cos del correu, a la descripció",
  "settings.mail.empty": "Encara no hi ha cap compte de correu.",
  "settings.mail.firstRun": "La primera lectura d’una carpeta no ingereix res: es comença des d’ara.",
  "settings.mail.folder": "Carpeta",
  "settings.mail.folderPlaceholder": "Nom de la carpeta",
  "settings.mail.foldersFailed": "No s’han pogut llegir. Escriu-la.",
  "settings.mail.host": "Servidor IMAP",
  "settings.mail.inboxVisible": "Surt a l’inbox de Tasques",
  "settings.mail.intro": "Els comptes de correu són teus i no de la casa: ningú més els veu, ni l’administrador.",
  "settings.mail.lastPolled": "Última lectura: {when}",
  "settings.mail.loadingFolders": "Llegint les carpetes…",
  "settings.mail.name": "Nom",
  "settings.mail.neverPolled": "Encara no s’ha llegit.",
  "settings.mail.notTouched": "Res marca els teus correus com a llegits.",
  "settings.mail.password": "Contrasenya",
  "settings.mail.passwordKept": "Desada. Deixa-la buida.",
  "settings.mail.passwordKept.long": "Ja hi és desada. Deixa el camp buit per no tocar-la.",
  "settings.mail.pickFolder": "Tria una carpeta…",
  "settings.mail.port": "Port",
  "settings.mail.project": "Projecte",
  "settings.mail.projectNone": "L’espai general",
  "settings.mail.remove": "Treu",
  "settings.mail.rules": "Carpetes",
  "settings.mail.rules.empty": "Cap carpeta mapada. Una carpeta sense regla no es llegeix mai.",
  "settings.mail.save": "Desa",
  "settings.mail.scope": "Àmbit",
  "settings.mail.security": "Seguretat",
  "settings.mail.security.starttls": "STARTTLS · port 143",
  "settings.mail.security.tls": "TLS · port 993",
  "settings.mail.template": "Títol de la tasca",
  "settings.mail.templatePreset": "Remitent - Assumpte",
  "settings.mail.templatePreview": "Es veurà: {preview}",
  "settings.mail.templateUnknown": "Variables que no existeixen: {vars}",
  "settings.mail.test": "Prova la connexió",
  "settings.mail.testFail": "No ha anat: {error}",
  "settings.mail.testOk": "Connectat. {count} carpetes.",
  "settings.mail.testing": "Provant…",
  "settings.mail.username": "Usuari",
  "settings.mcpEnable": "Activar MCP",
  "settings.mcpInstructions": "Per connectar-hi un client, fes servir aquesta adreça i un token amb les capacitats que li vulguis donar.",
  "settings.mcpUrl": "URL MCP",
  "settings.memberRemove": "Treure",
  "settings.members": "Membres",
  "settings.newAgent": "+ Nou agent",
  "settings.newCalendar": "+ Nou calendari",
  "settings.newPassword": "Contrasenya nova",
  "settings.newProject": "Projecte nou",
  "settings.newScope": "+ Nou àmbit",
  "settings.noProjects": "Cap projecte en aquest àmbit.",
  "settings.noun.client": "Clients",
  "settings.noun.project": "Projectes",
  "settings.overtimeVisible": "Ensenyar les hores fora d'horari com a extres",
  "settings.passwordChanged": "Contrasenya canviada. S'han tancat les altres sessions.",
  "settings.profileEmail": "Correu",
  "settings.profileName": "Nom",
  "settings.projectDelete": "Esborrar el projecte",
  "settings.projectName": "Nom del projecte",
  "settings.projects": "Projectes",
  "settings.projectsHelp": "Un projecte viu dins d'un àmbit. A l'afegida ràpida s'hi arriba amb #Àmbit/Projecte.",
  "settings.role.admin": "Administrador",
  "settings.role.collaborator": "Col·laborador",
  "settings.role.member": "Membre",
  "settings.role.owner": "Propietari",
  "settings.role.viewer": "Només lectura",
  "settings.scopeCancel": "Cancel·lar",
  "settings.scopeColor": "Color",
  "settings.scopeDelete": "Esborrar l'àmbit",
  "settings.scopeDeleteConfirm": "S'esborrarà «{name}». Només es pot si és buit.",
  "settings.scopeEdit": "Editar",
  "settings.scopeJoin": "Sincronitzar",
  "settings.scopeKind": "Tipus",
  "settings.scopeKind.collective": "Col·lectiu",
  "settings.scopeKind.individual": "Individual",
  "settings.scopeLeave": "Sortir de l'àmbit",
  "settings.scopeLeaveConfirm": "Deixaràs de veure «{name}» i el que hi hagi a dins.",
  "settings.scopeMode": "Com reparteixes la feina",
  "settings.scopeMode.both": "ho tria cadascú",
  "settings.scopeMode.fixed": "Aquesta instància està configurada en «{mode}» i això no es pot canviar des d'aquí.",
  "settings.scopeMode.help": "Ho pots canviar quan vulguis: no es mou ni s'esborra res, només canvia què hi ha a la barra de dalt.",
  "settings.scopeMode.multi": "Per àmbits",
  "settings.scopeMode.multi.hint": "Els àmbits a la barra: Personal, Feina, Família… i els projectes dins de cadascun.",
  "settings.scopeMode.single": "Per projectes",
  "settings.scopeMode.single.hint": "Els projectes a la barra. Els àmbits segueixen existint i es trien a l'esquerra.",
  "settings.scopeName": "Nom",
  "settings.scopeOwner": "Propietari",
  "settings.scopeSave": "Desar",
  "settings.scopeServerUrl": "Adreça del servidor (https://…)",
  "settings.scopeSource.here": "D'aquest servidor",
  "settings.scopeSource.new": "De nou",
  "settings.scopeSource.remote": "D'un altre servidor",
  "settings.scopeSourceHelp": "Qui comparteix l'àmbit et dona un token. Si és d'aquest mateix servidor només cal el token; si és d'un altre, també l'adreça.",
  "settings.scopeToken": "Enganxa el token del convit",
  "settings.scopeType": "Tipus",
  "settings.scopeType.individual": "Individual",
  "settings.scopeType.collective": "Col·lectiu",
  "settings.inviteUrl": "Enllaç d'invitació",
  "settings.invites": "Convits",
  "settings.noInvites": "Cap convit actiu.",
  "settings.noMembers": "Cap membre.",
  "settings.sharedCalendars": "Calendaris que es comparteixen",
  "settings.showCalendarWidget": "Calendari en miniatura",
  "settings.showOverdueSection": "Secció d'endarrerides",
  "settings.source": "Aquesta instància fa servir Fem-ho {version}, sota llicència {license}.",
  "settings.sourceLink": "El codi",
  "settings.sources": "Fonts de dades",
  "settings.sources.add": "+ Afegir font",
  "settings.sources.empty": "Aquest àmbit no té cap font externa. Les que hi afegeixis es veuran al calendari.",
  "settings.sources.failed": "L'últim refresc va fallar: {reason}",
  "settings.sources.inbox": "A la bústia",
  "settings.sources.kind.caldav": "CalDAV",
  "settings.sources.kind.ical": "iCal",
  "settings.sources.kind.rss": "RSS",
  "settings.sources.name": "Nom",
  "settings.sources.never": "Encara no s'ha refrescat.",
  "settings.sources.password": "Contrasenya",
  "settings.sources.readOnly": "De només lectura.",
  "settings.sources.refreshed": "Refrescada {when}.",
  "settings.sources.remove": "Treure",
  "settings.sources.url": "Adreça",
  "settings.sources.urlRequired": "La font necessita una adreça.",
  "settings.sources.username": "Usuari",
  "settings.empty.admin": "Encara no hi ha contingut per a Admin.",
  "settings.empty.ai": "Encara no hi ha contingut per a Usuari IA.",
  "settings.empty.mail": "Encara no hi ha contingut per a Correu.",
  "settings.empty.mcp": "Encara no hi ha contingut per a MCP i API.",
  "settings.empty.profile": "Encara no hi ha contingut per a Perfil.",
  "settings.empty.scopes": "Encara no hi ha contingut per a Àmbits.",
  "settings.tab.admin": "Admin",
  "settings.tab.ai": "Usuari IA",
  "settings.tab.calendars": "Calendaris",
  "settings.tab.general": "General",
  "settings.tab.mail": "Correu",
  "settings.tab.mcp": "MCP i API",
  "settings.tab.profile": "Perfil",
  "settings.tab.scopes": "Àmbits",
  "settings.tab.shares": "Compartits",
  "settings.theme": "Tema",
  "settings.theme.dark": "Fosc",
  "settings.theme.light": "Clar",
  "settings.theme.system": "Sistema",
  "settings.timezone": "Fus horari",
  "settings.title": "Ajustos",
  "settings.tracking": "Registre",
  "settings.trackingBackfilled": "S'han recuperat {count} blocs de dedicació de l'historial.",
  "settings.trackingHelp": "Quan una tasca passa per «Fent», el temps que hi està queda registrat. En activar-ho es recupera el que ja hi ha a l'historial.",
  "settings.trackingOn": "Anotar la dedicació d'aquest àmbit",
  "settings.typeNew": "Nova tipologia",
  "settings.typesOn": "Fer servir tipologies de tasca",
  "settings.typesRequired": "Obligatòria per crear una tasca",
  "settings.update.available": "Hi ha la versió {version}.",
  "settings.update.see": "Veure què ha canviat",
  "settings.update.unreachable": "No s'ha pogut consultar si hi ha una versió més nova.",
  "settings.users": "Membres de la llar",
  "settings.weekStart": "Primer dia de la setmana",
  "settings.weekStart.auto": "Segons l’idioma ({day})",
  "settings.wipe": "Netejar instància",
  "settings.wipeConfirm": "Escriu «{name}» per confirmar",
  "settings.wipeWarning": "Això esborra totes les tasques, esdeveniments, llistes i l'historial. Els comptes es queden.",
  "settings.workHours": "Horari laboral",
  "setup.name": "El teu nom",
  "setup.scope.family": "Família",
  "setup.scope.personal": "Personal",
  "setup.scope.work": "Feina",
  "setup.submit": "Crear el compte",
  "setup.subtitle": "Crea el primer compte d'administrador d'aquesta instància.",
  "setup.title": "Comencem",
  "share.accesses": "Accessos",
  "share.enter": "Entrar",
  "share.enterName": "Com et dius?",
  "share.enterPassword": "Aquest enllaç demana una contrasenya",
  "share.expired": "Aquest enllaç ja no és vàlid.",
  "share.expiresAt": "Caduca el",
  "share.lastAccess": "Últim accés",
  "share.maxViews": "Visites màximes",
  "share.password": "Contrasenya",
  "share.passwordPlaceholder": "Sense contrasenya",
  "share.permission": "Què pot fer qui obri l'enllaç",
  "share.permission.check": "Marcar ítems",
  "share.permission.comment": "Marcar i comentar",
  "share.permission.view": "Només mirar",
  "share.pointsTo": "Apunta a",
  "share.requireName": "Demanar el nom a qui hi entri",
  "share.revoke": "Revocar",
  "share.revoked": "Revocat",
  "share.title": "Compartir",
  "share.wrong": "No hi ha manera d'entrar amb això.",
  "shortcuts.calendar": "Calendari",
  "shortcuts.close": "Tancar",
  "shortcuts.dashboard": "Tauler general",
  "shortcuts.help": "Aquesta ajuda",
  "shortcuts.quickAdd": "Anar a l'afegida ràpida",
  "shortcuts.scopeN": "Commutar l'àmbit N",
  "shortcuts.search": "Cercar",
  "shortcuts.settings": "Ajustos",
  "shortcuts.tasks": "Tasques",
  "shortcuts.title": "Dreceres de teclat",
  "source.caldav": "D’un calendari CalDAV",
  "source.ical": "D’un calendari subscrit",
  "source.mail": "D’un correu",
  "source.rss": "D’un canal RSS",
  "state.empty.pinned": "No tens cap llista pinejada.",
  "state.empty.projects": "Aquest àmbit encara no té cap projecte.",
  "state.empty.scopes": "Encara no tens cap àmbit. Crea'n un a Ajustos.",
  "state.empty.search": "No s'ha trobat res.",
  "state.loading": "Carregant…",
  "stats.average": "Mitjana per tasca",
  "stats.byPerson": "Dedicació per persona",
  "stats.byProject": "Dedicació per projecte",
  "stats.byProject.client": "Dedicació per client",
  "stats.byType": "Dedicació per tipologia",
  "stats.evolution": "Evolució de la dedicació",
  "stats.evolutionWeekly": "Evolució de la dedicació, per setmanes",
  "stats.noType": "Sense tipologia",
  "stats.overtime": "Hores extres per projecte",
  "stats.overtime.client": "Hores extres per client",
  "stats.period.all": "Tot",
  "stats.period.days30": "Últims 30 dies",
  "stats.period.days365": "Últim any",
  "stats.period.days7": "Últims 7 dies",
  "stats.period.days90": "Últims 90 dies",
  "stats.projects": "Projectes actius",
  "stats.projects.client": "Clients actius",
  "stats.subtitle": "Dedicació de l'equip: per tipologia, per projecte, per persona i com evoluciona en el temps.",
  "stats.tasks": "Tasques fetes",
  "stats.title": "Estadístiques",
  "stats.total": "Dedicació total",
  "sync.appliedByServer": "Aplicades pel servidor",
  "sync.complete": "Fes-la",
  "sync.conflict": "Aquesta tasca s'ha canviat als dos costats. Quina versió vols?",
  "sync.goOffline": "Desconnecta",
  "sync.goOnline": "Reconnecta",
  "sync.keepMine": "La meva",
  "sync.keepTheirs": "La de l'altre dispositiu",
  "sync.now": "Sincronitza ara",
  "sync.offline": "Sense connexió",
  "sync.online": "En línia",
  "sync.pending": "Pendent de pujar",
  "sync.remoteEdit": "Canvi des d'un altre dispositiu",
  "sync.rename": "Reanomena",
  "sync.renameSuffix": "·",
  "sync.synced": "Sincronitzat",
  "sync.title": "Sincronització",
  "task.activity": "Historial",
  "task.addAttachment": "Adjuntar un fitxer",
  "task.aiConversation": "Conversa amb la IA",
  "task.aiInstructions": "Instruccions per a la IA",
  "task.aiMode": "Mode d'IA",
  "task.aiReply": "Respon a l'agent…",
  "task.assignees": "Assignat a",
  "task.attachmentLink": "Enllaç extern",
  "task.attachmentTooBig": "El fitxer passa del límit de {limit_mb} MB.",
  "task.attachments": "Adjunts",
  "task.checklists": "Llistes senzilles",
  "task.comments": "Comentaris",
  "task.deadline": "Data límit",
  "task.deleteConfirm": "Vols esborrar definitivament «{title}»? També s’esborraran les seves subtasques i llistes. Si prové d’un esdeveniment del calendari, l’esdeveniment es conservarà.",
  "task.description": "Descripció",
  "task.dueDate": "Data",
  "task.dueTime": "Hora",
  "task.edit": "Editar tasca",
  "task.empty.activity": "Encara no ha passat res en aquesta tasca.",
  "task.empty.aiConversation": "Encara no us heu dit res.",
  "task.empty.attachments": "Cap fitxer adjunt.",
  "task.empty.comments": "Encara no hi ha cap comentari.",
  "task.empty.labels": "Aquest àmbit encara no té cap etiqueta.",
  "task.empty.subtasks": "Aquesta tasca no té subtasques.",
  "task.label.add": "Posar aquesta etiqueta",
  "task.label.remove": "Treure aquesta etiqueta",
  "task.labels": "Etiquetes",
  "task.new": "Nova tasca",
  "task.newChecklist": "+ Nova llista",
  "task.newComment": "Escriu un comentari…",
  "task.newLabel": "+ Nova etiqueta",
  "task.newLabel.placeholder": "Nom de l’etiqueta",
  "task.newSubtask": "+ Afegir subtasca…",
  "task.noProject": "Espai general",
  "task.project": "Projecte",
  "task.project.client": "Client",
  "task.recurrence": "Repetició",
  "task.recurrence.daily": "Cada dia",
  "task.recurrence.explain": "Amb això, la següent surt del dia que la facis i no del venciment.",
  "task.recurrence.fromCompletion": "Comptar des que es completa",
  "task.recurrence.monthly": "Cada mes",
  "task.recurrence.none": "No es repeteix",
  "task.recurrence.weekly": "Cada setmana",
  "task.recurrence.yearly": "Cada any",
  "task.removeAttachment": "Treure",
  "task.scope": "Àmbit",
  "task.send": "Envia",
  "task.share": "Compartir",
  "task.status": "Estat",
  "task.subtasks": "Subtasques",
  "task.taskType": "Tipologia",
  "task.title": "Títol",
  "task.titleEditHint": "Mantén premut el títol i deixa anar per editar-lo · F2 amb teclat",
  "task.titleEditKeys": "Enter per desar · Escape per cancel·lar",
  "task.titleRequired": "El títol no pot quedar buit.",
  "tokens.aiOwned": "Credencial d'IA de «{name}»",
  "tokens.aiOwnedGo": "Anar a l'agent",
  "tokens.aiOwnedHelp": "Les credencials d'IA es creen i es revoquen a Usuari IA, on també es diu quins àmbits porta cada agent.",
  "tokens.capabilities": "Capacitats",
  "tokens.copied": "Copiat",
  "tokens.copy": "Copia",
  "tokens.create": "Crea un token",
  "tokens.lastUsed": "Últim ús",
  "tokens.name": "Nom",
  "tokens.never": "Mai",
  "tokens.onceWarning": "Apunta'l ara: no es podrà tornar a veure mai més.",
  "tokens.prefix": "Prefix",
  "tokens.revoke": "Revoca",
  "tokens.scopes": "Àmbits",
  "tokens.title": "Tokens d'API",
  "welcome.changeable": "Ho pots canviar sempre que vulguis a Ajustos. No es mou ni s’esborra res.",
  "welcome.lead": "Tria com vols veure Fem-ho. No hi ha resposta dolenta i es canvia quan vulguis.",
  "welcome.multi": "Per àmbits de la vida",
  "welcome.multi.body": "A dalt hi tens Personal, Feina, Família… i pots mirar-ne un o uns quants alhora. Dins de cada àmbit hi caben projectes.",
  "welcome.preview.family": "Família",
  "welcome.preview.personal": "Personal",
  "welcome.preview.projectA": "Obres",
  "welcome.preview.projectB": "Clients",
  "welcome.preview.scope": "Feina",
  "welcome.preview.work": "Feina",
  "welcome.single": "Per projectes d’una sola cosa",
  "welcome.single.body": "A dalt hi tens els projectes. Va bé si fas servir Fem-ho per a una sola cosa: la teva feina, la teva empresa, un projecte.",
  "welcome.title": "Com reparteixes la feina?",
  "widget.board.description": "Tria Inbox, Per fer o Fent i toca una tasca per avançar-la.",
  "widget.board.name": "Fem-ho · Tasques",
  "widget.more": "+{count} més",
  "widget.pending": "pendents",
  "widget.pinned.choose": "Tria quina llista vols veure",
  "widget.pinned.description": "Una llista pinejada, per marcar des de la pantalla d'inici.",
  "widget.pinned.name": "Fem-ho · Llista",
  "widget.quickAdd.description": "Apunta una tasca sense obrir l'app.",
  "widget.quickAdd.name": "Fem-ho · Afegir",
  "widget.signedOut": "Connecta't per veure les teves tasques.",
  "widget.today.description": "El que venç avui, amb afegida ràpida.",
  "widget.today.name": "Fem-ho · Avui",
  "settings.workStart": "Hora d'inici",
  "settings.workEnd": "Hora de final",
  "settings.workDays": "Dies laborables",
  "settings.longSessionHours": "Hores de sessió llarga",
  "settings.labelNew": "+ Nova etiqueta",
  "settings.labelDelete": "Esborrar l'etiqueta",
  "settings.typeDelete": "Esborrar la tipologia",
  "settings.entityLabels": "Etiquetes",
  "settings.entityTypes": "Tipologies",
  "settings.entityDedication": "Dedicació",
  "settings.entityProjects": "Projectes",
  "settings.scopeSection": "Gestió de l'àmbit",
  "notification.snooze": "Ajorna",
  "login.certTitle": "Certificat no reconegut",
  "login.certBody": "El servidor presenta un certificat autofirmat o d'una CA pròpia. Compara l'empremta amb la que esperes i, si hi coincideix, confirma-la per connectar-hi.",
  "login.certFingerprint": "Empremta",
  "login.certConfirm": "Confia en aquest certificat",
  "login.certReject": "Cancel·la",
  "reports.title": "Informes",
  "reports.subtitle": "Què has acabat i on has dedicat el temps.",
  "reports.tab.summary": "Resum",
  "reports.tab.time": "Dedicació",
  "reports.tab.register": "Registre de temps",
  "reports.print": "Imprimeix / Desa com a PDF",
  "reports.values": "Mostra els valors",
  "reports.period": "Període",
  "reports.from": "Des de",
  "reports.to": "Fins a",
  "reports.period.today": "Avui",
  "reports.period.week": "Setmana actual",
  "reports.period.month": "Mes actual",
  "reports.period.days30": "Últims 30 dies",
  "reports.period.days90": "Últims 90 dies",
  "reports.period.all": "Tot",
  "reports.period.custom": "Personalitzat",
  "reports.assignee": "Persona assignada",
  "reports.person": "Persona que registra temps",
  "reports.allTypes": "Totes les tipologies",
  "reports.invalidRange": "La data final ha de ser igual o posterior a la inicial.",
  "reports.exportError": "No s’ha pogut exportar. Torna-ho a provar.",
  "reports.loading": "Carregant l’informe…",
  "reports.trackingDisabled": "Els àmbits seleccionats no tenen activat el registre de dedicació. El resum de tasques continua disponible.",
  "reports.configure": "Configura el registre de dedicació",
  "reports.current": "Estat actual",
  "reports.activity": "Activitat del període",
  "reports.completedHint": "Compta tasques que ara estan fetes i es van completar dins del període. Les reobertes i les esborrades no hi compten.",
  "reports.metric.pending": "Pendents ara",
  "reports.metric.overdue": "Endarrerides ara",
  "reports.metric.created": "Creades al període",
  "reports.metric.completed": "Fetes al període",
  "reports.evolution": "Evolució de les tasques",
  "reports.week": "Setmana",
  "reports.projects": "Per projecte",
  "reports.projects.client": "Per client",
  "reports.empty": "No hi ha resultats amb aquests filtres.",
  "reports.status": "Estat",
  "reports.trackedTasks": "Tasques amb dedicació",
  "reports.trackedProjects": "Projectes amb dedicació",
  "reports.trackedProjects.client": "Clients amb dedicació",
  "reports.visibility": "La dedicació inclou els teus blocs i els de tot l’àmbit només quan tens permís per veure’ls.",
  "reports.firstPage": "Primera pàgina",
  "reports.nextPage": "Pàgina següent",
  "reports.generated": "Calculat el {at}",
  "reports.openSessions": "Inclou {count} sessions en curs.",
  "error.invalid-report-filter": "Revisa les dates, els projectes i la mida de pàgina de l’informe.",
  "reports.allProjects": "Tots",
  "reports.paginationHint": "Els totals inclouen totes les coincidències. La llista mostra fins a 100 resultats per pàgina.",
  "chrono.edit": "Edita el temps",
  "chrono.add": "Afegeix temps",
  "chrono.taskChoice": "Tasca",
  "chrono.newTask": "Tasca nova",
  "chrono.existingTask": "Tasca existent",
  "chrono.title": "Títol",
  "chrono.createdDone": "Es crearà com a feta, amb aquest bloc de dedicació.",
  "chrono.selectTask": "Selecciona una tasca",
  "chrono.refineSearch": "Hi ha més tasques. Afina la cerca per trobar-les.",
  "chrono.start": "Inici",
  "chrono.end": "Final",
  "chrono.running": "En curs",
  "chrono.moveWarning": "Confirmo que es mourà tota la tasca i tota la seva dedicació al projecte seleccionat.",
  "chrono.saveError": "No s’ha pogut desar. Revisa les hores, els permisos o si la sessió ha canviat; les dades s’han recarregat.",
  "chrono.openTask": "Obre la tasca",
  "chrono.sameScope": "Tria un projecte del mateix àmbit. El bloc no s’ha mogut.",
  "chrono.zoomOut": "Allunya",
  "chrono.zoomIn": "Apropa",
  "chrono.hint": "Arrossega les vores per ajustar el temps, el bloc per moure’l o un espai buit per crear-ne un. Ajust a 5 minuts. Clica el bloc per editar sense arrossegar.",
  "error.session-forbidden": "No pots editar aquesta dedicació.",
  "error.session-conflict": "La sessió ha canviat. Recarrega-la abans d’editar.",
  "error.invalid-session": "Revisa les dades del bloc de dedicació.",
  "settings.showReports": "Mostra Informes a la barra principal",
  "settings.showReportsHint": "Si ho desactives, trobaràs Informes al menú de la teva foto de perfil.",
  "reports.tools": "Exporta o imprimeix",
  "reports.exportContent": "Contingut del CSV",
  "reports.exportTasks": "Tasques · {metric}",
  "reports.registerTitle": "Temps registrat",
  "reports.registerHint": "El temps es registra en passar per Fent o en indicar la durada quan completes directament una tasca. Cada tram es conserva per separat.",
  "reports.filters": "Filtres",
  "reports.clearFilters": "Neteja els filtres",
  "reports.openRegister": "Obre el registre de temps",
  "reports.timeDetails": "Desglossament del temps",
  "reports.closeDetails": "Tanca el detall",
  "reports.recordedTasks": "Temps anotat en {count} tasques",
  "reports.seeCompleted": "Veure les tasques fetes",
  "reports.aboutData": "Sobre aquestes dades",
  "tracking.cardsTitle": "Dedicació a les targetes",
  "tracking.showCards": "Mostra el temps a Fent i Fet",
  "tracking.cardsHint": "Suma tots els trams visibles. A Fent, el comptador avança cada segon; a Fet, mostra el total. Només als àmbits amb el registre activat.",
  "tracking.askDuration": "Quanta estona hi has dedicat?",
  "tracking.completionHint": "L’àmbit té el registre de temps activat. Anota la durada per completar la tasca i afegir un tram de feina.",
  "tracking.minutes": "Durada en minuts",
  "tracking.saveComplete": "Desa el temps i marca com a feta",
  "tracking.invalidDuration": "Introdueix entre 1 i 10.080 minuts.",
  "tracking.total": "Dedicació: {duration}",
  "tracking.oneSegment": "1 tram",
  "tracking.segments": "{count} trams",
  "tracking.seconds": "{count}s",
  "widget.chooseColumn": "Què vols veure al widget?",
  "widget.configure": "Configura",
  "widget.columnEmpty": "No hi ha tasques en aquesta columna.",
  "widget.advance": "→ {column}",
  "widget.pendingSync": "Canvi desat al mòbil. Pendent de sincronitzar.",
  "widget.taskBoard.name": "Fem-ho · Tauler",
  "widget.taskBoard.description": "Inbox, Per fer i Fent. Toca una tasca per avançar-la.",
  "widget.taskBoard.open": "Obre",
  "widget.taskBoard.viewAll": "Veure totes",
  "widget.taskBoard.empty": "Cap tasca.",
  "widget.taskBoard.advance": "{task}. Passa a {column}.",
  "external.credentials": "Credencials"
}
